import { useQuery } from "@tanstack/react-query";
import { SubTrends } from "./sub-trend";

import deskripsiData from "@/data/desckripsi-sector.json";
import { TrendsLineChart } from "./line-chart";
import React from "react";
import { Spin } from "antd";

const BASE_URL = "";

interface Props {
  slug: string;
  researchId: string;
}

export const GTrendSectorDetails: React.FC<Props> = ({
  slug,
  researchId,
}) => {
  let deskripsiDataP: any = deskripsiData;

  // slug = encodeURIComponent(slug)

  const { data, isPending } = useQuery<{
    lastCrawl: string;
    trends: any;
    tbdDocs?: any;
    brandTrends?: any;
  }>({
    queryKey: [`trend-sector-details`, researchId, slug],
    queryFn: () =>
      fetch(`${BASE_URL}/api/riset/sector/${researchId}?${new URLSearchParams({ slug })}`, {
        cache: "default",
      }).then((res) => res.json()),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  // React.useEffect(() => {
  //   console.log(data);
  // }, [data]);

  return (
    <>
      <div className="space-y-5">
        <section className="text-justify">
          <Spin tip="Loading" size="large" spinning={isPending}>
            <TrendsLineChart data={data?.tbdDocs} slug={slug} />
          </Spin>
          {/* {data ? (
            
          ) : (
            <Loading />
          )} */}

          <p className="text-gray-400 text-[0.875rem] my-5">
            Data ini berasal dari Google Trends, dan menunjukkan hasil tren
            rata-rata seluruh kata kunci, merek dan topik umum yang kami lacak
            di sektor {slug.toLowerCase()}.
          </p>
        </section>

        <section className="">
          {data && data.brandTrends && data.brandTrends[1] ? (
            <div className="flex items-center justify-between border border-solid border-black rounded-lg p-5">
              <p className="text-black">Pencarian topik umum berubah sebesar</p>
              <h2 className="text-black text-4xl font-bold">
                {data.brandTrends[1].toFixed(1)}%
              </h2>
            </div>
          ) : null}
        </section>

        <section
          className="flex flex-col justify-center items-center h-[30vh] max-w-screen bg-cover shadow-[inset_0_0_0_1920px_rgba(0,0,0,0.5)] rounded-lg"
          style={{
            backgroundImage: `url('/images/sectors/${encodeURIComponent(
              slug.toLowerCase().replace(/,/g, "").replace(/ /g, "-")
            )}.jpg')`,
          }}
        >
          <div>
            <h1 className="text-white text-3xl text-center font-bold drop-shadow-[0_5px_5px_rgba(255,255,255,0.25)]">
              Sektor {slug}
            </h1>
          </div>
        </section>

        <section className="text-justify">
          <p className="text-gray-600 text-xs leading-6">
            {deskripsiDataP[slug.toLowerCase().replace(/,/g, "").replace(/ /g, "-")]}
          </p>
        </section>

        {data?.trends && (
          <>
            <section className="py-5">
              <SubTrends
                dir="up"
                data={data?.trends ? data?.trends[0] : []}
                lastCrawl={data?.lastCrawl}
                slug={slug}
              />
            </section>

            <section className="py-4 mt-5">
              <SubTrends
                dir="down"
                data={data?.trends ? data?.trends[0] : []}
                lastCrawl={data?.lastCrawl}
                slug={slug}
              />
            </section>
          </>
        )}

        {data?.brandTrends && (
          <>
            <section className="py-5">
              <SubTrends
                dir="up"
                data={data?.brandTrends ? data.brandTrends[0] : []}
                lastCrawl={data?.lastCrawl}
                slug={slug}
                isBrand
              />
            </section>

            <section className="py-4 mt-5">
              <SubTrends
                dir="down"
                data={data?.brandTrends ? data.brandTrends[0] : []}
                lastCrawl={data?.lastCrawl}
                slug={slug}
                isBrand
              />
            </section>
          </>
        )}
      </div>
    </>
  );
}
